import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const shipmentPackagesCommonStyle = {
    dataTable: {
        css: css`
            th,
            td {
                text-align: center;

                &:first-child {
                    text-align: left;
                }
            }
            margin: 1.5em 0;
        `,
    },
    trackingNumberCell: {
        css: css`
            a {
                color: ${getColor("text.link")};
                text-decoration: underline ${getColor("text.link")};

                &:hover,
                &:focus {
                    text-decoration: none;
                }
            }
        `,
    },
};
